import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/Tabs';
import BlogPostsTab from '../../components/admin/blog/BlogPostsTab';
import ServiceRequestsTab from '../../components/admin/requests/ServiceRequestsTab';
import UsersTab from '../../components/admin/UsersTab';
import LocationsTab from '../../components/admin/LocationsTab';
import StatsOverview from '../../components/admin/stats/StatsOverview';

export default function Dashboard() {
  return (
    <>
      <Helmet>
        <title>Admin Dashboard | Parakh Services</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="space-y-8">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Dashboard Overview</h1>
        </div>

        <StatsOverview />

        <Tabs defaultValue="blog" className="space-y-6">
          <TabsList className="bg-white p-1 rounded-lg shadow-sm border border-gray-200">
            <TabsTrigger value="blog">Blog Posts</TabsTrigger>
            <TabsTrigger value="requests">Service Requests</TabsTrigger>
            <TabsTrigger value="users">Users</TabsTrigger>
            <TabsTrigger value="locations">Locations</TabsTrigger>
          </TabsList>

          <TabsContent value="blog">
            <BlogPostsTab />
          </TabsContent>

          <TabsContent value="requests">
            <ServiceRequestsTab />
          </TabsContent>

          <TabsContent value="users">
            <UsersTab />
          </TabsContent>

          <TabsContent value="locations">
            <LocationsTab />
          </TabsContent>
        </Tabs>
      </div>
    </>
  );
}